import Head from 'next/head';
import { useRouter } from 'next/router';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MindkeyJobAgent } from '2-feature/Mindkey/JobAgent';
import { Breadcrumb } from '2-feature/Navgation/Breadcrumb';
import { Speaker } from '2-feature/Speaker/Speaker';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';

interface Props {
	customerId: string;
}

export const JobAgentPage = ({ customerId }: Props) => {
	const dictionary = useDictionaryContext();
	const { locale } = useRouter();
	const heading = dictionary.getJob('JobAgentHeading', locale);

	return (
		<>
			<Head>
				<title>{heading}</title>
			</Head>
			<MainRegion breadCrumb={<Breadcrumb additionalBreadcrumbItems={[{ title: heading }]} />} speaker={<Speaker noBottomSpacing={true} />}>
				<UI_HeaderCard heading={heading} />
				<UI_Container width="Small">
					<MindkeyJobAgent customerId={customerId} />
				</UI_Container>
				<GoToTopNavigation />
			</MainRegion>
		</>
	);
};
